<div class="modal-header">
  <h5 class="modal-title">Thêm tác giả</h5>
  <button type="button" class="close" aria-label="Đóng" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
<form style="background-color: white; padding: 20px; border-radius: 5px;" class="row" [formGroup]="writerForm">
  
  <!-- Name -->
  <div class="form-group col-md-6">
    <label for="name">Tên:</label>
    <i class="fas fa-info-circle" data-toggle="tooltip" 
       title="Mô tả: Nhập tên của tác giả. Ví dụ: Nguyễn Nhật Ánh"></i>
    <input [ngClass]="{ 'is-invalid': submitted && f.name.errors }" 
           formControlName="name" id="field-category_name" 
           name="name" class="form-control" type="text" maxlength="99" />
    <!-- Name validation -->
    <div *ngIf="submitted && f.name.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.name.errors.required">
        Tên là bắt buộc.
      </div>
    </div>
  </div>

  <!-- Note -->
  <div class="form-group col-md-6">
    <label for="note">Ghi chú:</label>
    <i class="fas fa-info-circle" data-toggle="tooltip" 
       title="Mô tả: Nhập ghi chú về tác giả. Ví dụ: Nổi tiếng với tiểu thuyết lịch sử"></i>
    <input [ngClass]="{ 'is-invalid': submitted && f.note.errors }" 
           formControlName="note" id="field-note" 
           name="note" class="form-control" type="text" maxlength="99" />
    <!-- Note validation -->
    <div *ngIf="submitted && f.note.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.note.errors.required">
        Ghi chú là bắt buộc.
      </div>
    </div>
  </div>

  <!-- Date of Birth -->
  <div class="form-group col-md-6">
    <label for="dob">Ngày sinh:</label>
    <i class="fas fa-info-circle" data-toggle="tooltip" 
       title="Mô tả: Nhập ngày sinh của tác giả."></i>
    <input [ngClass]="{ 'is-invalid': submitted && f.dob.errors }" 
           formControlName="dob" id="field-dob" 
           name="dob" class="form-control" type="date" />
    <!-- Date of Birth validation -->
    <div *ngIf="submitted && f.dob.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.dob.errors.required">
        Ngày sinh là bắt buộc.
      </div>
    </div>
  </div>

  <!-- Died -->
  <div class="form-group col-md-6">
    <label for="died">Đã mất:</label>
    <i class="fas fa-info-circle" data-toggle="tooltip" 
       title="Mô tả: Chọn nếu tác giả đã qua đời."></i>
    <div>
      <input type="radio" formControlName="died" id="died_yes" name="died" value="yes" />
      <label for="died_yes">Có</label>
      <input type="radio" formControlName="died" id="died_no" name="died" value="no" />
      <label for="died_no">Không</label>
    </div>
    <!-- Died validation -->
    <div *ngIf="submitted && f.died.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.died.errors.required">
        Trường này là bắt buộc.
      </div>
    </div>
  </div>

  <!-- Date of Death -->
  <div class="form-group col-md-6">
    <label for="dod">Ngày mất:</label>
    <i class="fas fa-info-circle" data-toggle="tooltip" 
       title="Mô tả: Nhập ngày mất, nếu có."></i>
    <input [ngClass]="{ 'is-invalid': submitted && f.dod.errors }" 
           formControlName="dod" id="field-dod" 
           name="dod" class="form-control" type="date" />
    <!-- Date of Death validation -->
    <div *ngIf="submitted && f.dod.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.dod.errors.required">
        Ngày mất là bắt buộc.
      </div>
    </div>
  </div>

  <!-- Bio -->
  <div class="form-group col-md-6">
    <label for="bio">Tiểu sử:</label>
    <i class="fas fa-info-circle" data-toggle="tooltip" 
       title="Mô tả: Nhập tiểu sử ngắn của tác giả."></i>
    <textarea [ngClass]="{ 'is-invalid': submitted && f.bio.errors }" 
              formControlName="bio" id="field-bio" 
              name="bio" class="form-control" rows="3"></textarea>
    <!-- Bio validation -->
    <div *ngIf="submitted && f.bio.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.bio.errors.required">
        Tiểu sử là bắt buộc.
      </div>
    </div>
  </div>

  <!-- Add Button -->
  <div class="col-md-12">
    <button (click)="add()" type="button" class="btn btn-outline-primary">
      <i class="fas fa-save"></i>
      {{ writerI18n?.addButtonI18n || 'Thêm mới' }}
    </button>
  </div>
</form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">
    {{ writerI18n?.closeButtonI18n || 'Đóng' }}
  </button>
</div>